// extracted by mini-css-extract-plugin
export default {"formItem":"AddEditRecordModal_formItem__lEo8I"};